export default "__VITE_ASSET__BN9m1Q$k__"